export const AUTHORITY_URL: { [key: string]: string } = {
  prod: "https://accounts.apmterminals.com/root",
  preprod: "https://accounts-stage.apmterminals.com/root-stage",
  test: "https://accounts-cdt.apmterminals.com/root-cdt",
  localhost: "https://accounts-cdt.apmterminals.com/root-cdt"
};

export const ENVIRONMENT_URL: { [key: string]: string } = {
  prod: "https://api.apmterminals.com",
  preprod: "https://api-stage.apmterminals.com",
  test: "https://api-cdt.apmterminals.com",
  localhost: "http://localhost:8080"
};

export const GRAFANA_CONFIG: { [key: string]: { environment: string; name: string; attribute: string } } = {
  prod: {
    environment: "prod",
    name: "APMT-TnT-prod",
    attribute: "mMi3wtx/T97tR/NPbJE19tGh39X9m+P5ggbsb7gAx7l7dU8AapOPHGtf7RgL4w=="
  },
  preprod: {
    environment: "preprod",
    name: "APMT-TnT-stage",
    attribute: "mMi3wtx/T9/rRvMYOcJi8DDkMtBDHMmBLJodXiq+qW3O4/7ch/ASW4ekaCOD0g=="
  },
  test: {
    environment: "cdt",
    name: "APMT-TnT-dev",
    attribute: "mMi3wtx/T9DrSKJOMsZn876HUsWSYfOOL0CqvISq5cFBvykmFtEGk8qDZXcJeg=="
  },
  localhost: {
    environment: "cdt",
    name: "APMT-TnT-dev",
    attribute: "mMi3wtx/T9DrSKJOMsZn876HUsWSYfOOL0CqvISq5cFBvykmFtEGk8qDZXcJeg=="
  }
};
